export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13169.c5a750ea.jpg";